import React from 'react'
import { AzureMP } from 'react-azure-mp'

function get_url_extension( url ) {
    return url.split(/[#?]/)[0].split('.').pop().trim();
}

export const VideoRender = ({ step, ...props}) => {
    const videotoken = 'Bearer ' + localStorage.getItem('videotoken');
    const videoFormat = type => {
        switch (type) {
            case 'mp4':
                return 'video/mp4'
        }
    }

    return (
        <div style={{ maxWidth: '100%', maxHeight: '100%', position: 'relative' }}>
            <AzureMP
                options={{
                    controls: true,
                    autoplay: false,
                    // fluid: true,
                    playbackSpeed: {
                        enabled: true,
                        initialSpeed: 1.0,
                        speedLevels: [
                            { name: "x2.0", value: 2.0 },
                            { name: "x1.5", value: 1.5 },
                            { name: "x1.25", value: 1.25 },
                            { name: "normal", value: 1.0 }
                        ]
                    }
                }}
             skin="amp-flush"
                src={[{
                    src: step.content,
                    type: "application/vnd.ms-sstr+xml",
                    protectionInfo: [
                        {
                            "type": "AES",
                            "authenticationToken": videotoken
                        }
                    ]
                }]}    
                style={{
                    width: '100%',
                    height: '100%',
                }}        
           />
        </div>
    )
}